<template>
  <div>
    <H2>Weekly Care Plan</H2>
    <b-button @click="handleToggleBusyClick">
      Toggle Busy State
    </b-button>
    <b-table
      :fields="fields"
      :items="items"
      :busy="isBusy"
      class="mt-3"
      outlined
    >
      <!-- A virtual column -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBusy: false,
      fields: [
        // A virtual column that doesn't exist in items
        "index",
        // A column that needs custom formatting
        { key: "name", label: "Question " },
        // A regular column
        "dosage"
      ],
      items: [
        { name: "Is Mary sleeping well", dosage: 40 },
        { name: "Is Mary's walling improving", dosage: 21 },
        { name: "Metformin", dosage: 89 },
        { name: "Metformin", dosage: 38 }
      ]
    };
  },
  methods: {
    handleToggleBusyClick() {
      this.isBusy = !this.isBusy;
    }
  }
};
</script>

<style lang="scss" scoped></style>
